import { State } from './gameReducer';

type LocalStorageState = { [roomId: string]: { id: string, state: Pick<State, 'hand' | 'board'> } };

export const getStateFromStorage = () => {
    try {
        const stateFromStorage: LocalStorageState = JSON.parse(localStorage.getItem('state') || '');
        return stateFromStorage;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const setStateToStorage = (state: LocalStorageState) => {
    localStorage.setItem('state', JSON.stringify(state));
};
